import { IconTruck, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import {
  MaxShipping,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { ShippingVariantView } from '../../../../../../ShippingVariantSelector/View'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: MaxShipping
}

export function MaxShippingView(props: Props) {
  const { onEdit, onRemove, config } = props

  const { formatCurrency } = useNumbers()

  const handleEdit = () => onEdit(RegularBenefitVariant.MaxShipping)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconTruck />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>{formatCurrency(config.value)}</Tag>
        <ShippingVariantView config={config} />
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
